import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyleCardBody } from 'styles/styledGlobal'

const StyleCardSession = styled.div`
  margin-bottom: 15px;
  width: 100%;
`
const StyleCardTitle = styled.div`
  font-weight: 800;
  text-transform: uppercase;
  color: #000000;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
`
const StyleTitle = styled.div`
  display: flex;
  align-items: end;
`

interface IProps {
  title?: string
  children?: React.ReactNode
  rightContent?: React.ReactNode
}
const CardLayout = (props: IProps) => {
  const { title, children, rightContent } = props
  const { t } = useTranslation()
  return (
    <StyleCardSession>
      {!!title && (
        <StyleCardTitle>
          <StyleTitle>{t(title || '')}</StyleTitle>
          {rightContent && rightContent}
        </StyleCardTitle>
      )}
      <StyleCardBody>{children}</StyleCardBody>
    </StyleCardSession>
  )
}

export default CardLayout
